module.exports = __webpack_public_path__ + "static/media/1.72650c39.jpg";